import "./App.css";
import AppRouter from './routes/index'
import '../src/language/i18n'
import { ScrollProvider } from "./components/ScrollManager";
import Modal from './components/modal/Modal';
import axios from 'axios';
const getLocation = async()=> {
  console.log(window.location)
  const currentUrl = window.location.href;
  let targetUrl = currentUrl


  if(window.location.href.includes('localhost')) return
  // 根据第三方请求 判断用户ip所在地
  // try {
  //   const response = await axios.get('https://ipapi.co/json/');
  //   const data = response.data;
  //   // console.log(currentUrl.replace("kunlunworld.cn", "kunlunworld.com"))
  //   // url = url.replace("https://kunlunworld.cn", "https://"+window.location.hostname)
  //   // 判断用户是否在中国 为防止重复改变地址 额外添加对当前地址的判断
  //   if (data.country === 'CN' && window.location.href.includes('kunlunworld.com')) {
  //     targetUrl = currentUrl.replace("kunlunworld.com", "kunlunworld.cn")
  //     window.location.href = targetUrl;
  //   } else if(data.country !== 'CN' && !window.location.href.includes('kunlunworld.com')) {
  //     targetUrl = currentUrl.replace("kunlunworld.cn", "kunlunworld.com")
  //     window.location.href = targetUrl;
  //   }
  // } catch (error) {
  //   console.error('请求失败:', error);
  // }
}


getLocation();
function App() {
  return (
    <ScrollProvider>
       <AppRouter />
       <Modal/>
    </ScrollProvider>
  );
}

export default App;
